import React from 'react';

import Page from '@/components/layout/page';
import { withAuth } from '@/components/with_auth';

import styles from '@/components/index/Index.module.css';
import MyNetworkDashboard from '@/components/my-network';

function MyNetwork() {
    return (
        <Page>
            <div className={`flex flex-wrap pl-4 sm:pl-8 pr-0 sm:pr-6 md:pr-0 ${styles.home} relative`}>
                <div className="flex-2 w-full pt-8 pb-8 pr-4 md:pr-10">
                    <div className={`${styles.homeContent}bg-lightGray`}>
                        <div className={styles.homeStats}>
                            <MyNetworkDashboard />
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    );
}
export default withAuth(MyNetwork);
